import React, { useState, useEffect } from 'react';
import { Form , Field, FormElement, FieldWrapper} from "@progress/kendo-react-form"
import SubHeader from "../components/SubHeader"
import { CusFormLabel, FormSubTitle, FormTitle,TermsFormCheckboxNoErrMsgDisplay,CusFormInput } from "../validation/Form-Components"
import taxData from '../data/taxdetailsdata.json'
import FormContainer from "../components/FormContainer"
import CusRadioButton from '../components/CusRadioButton'
import {  termsValidator, tinValidator } from '../validation/Validators'
import config from '../appconfig/config.json'
import CusProgressBar from '../components/CusProgressBar';
import service from '../services/ApiService.js';
import { useHistory } from "react-router-dom";
import TaxResidence from '../components/TaxResidence';
import fatcaList from '../data/fatcalist.json';
import Loading from '../components/Loading';
import helper from '../factory/Helper.js';
import CusToast from '../components/CusToast';
import countries from '../data/domicilecountries.json';
 

let USC=true, USPR=true, USR = true;
let couOfResiObj = {},couOfResiObj3 = {};; 
let defTin = '';
 
const TaxDetails = (props) => {

    let timer;
    const history = useHistory();
    const detailsType='6';
    const item = { bgcolor: "#389A6E", completed: 70 };
    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [isSaving, setIsSaving] = useState(false);

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [idNum, setIdNum] = useState();

    const defCountry = {value:"SG","label":"SINGAPORE"}; //default is singapore

    // const countryArray = taxData.topCountry.concat(countries);
 
    
    const [payTaxSGOnlySelected,setPayTaxSGOnlySelected] = useState('Y');
    const [showAddBtn, setShowAddBtn] = useState(true);
    const [USCSelected,setUSCSelected] = useState('N');
    const [USPRSelected,setUSPRSelected] = useState('N');
    const [USRSelected,setUSRSelected] = useState('N');
    const [NUSPSelected,setNUSPSelected] = useState('Y');
    const [disableNUSP,setDisableNUSP] = useState(true);
    
    const [taxDetails,setTaxDetails] = useState({
        CouOfTaxRes:defCountry.label, //default SG for Sole
        TIN: defTin,
        PayTaxSGOnly:'', 
 
    
        TaxNumber2:'',
        CouOfTaxRes2:'',
        AbleProvTIN2:'',
        ReasonUnableProvTIN2:'',

        TaxNumber3:'',
        CouOfTaxRes3:'',
        AbleProvTIN3:'',
        ReasonUnableProvTIN3:'',

        TaxClare:false
    })
 

    useEffect(() => {
        console.log('@TaxDetails useEffect')

        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }

     //   countries.sort(helper.dynamicSort('label'));
        window.scrollTo(0,0);
      
        couOfResiObj={}; couOfResiObj3={};
        getData();  

        return () => clearTimeout(timer);
    }, []);

    const handleSubmit = (eve) => {
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
        
        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }
        
        if(eve.isValid){
            let data = JSON.parse(JSON.stringify(eve.values));
            if(validateFATCA(data)){
               saveTaxDetails(formatJsonParams(data));
            }
        }
    }

    const getData = () => {
        service.get().then( res =>{
            setIsLoading(false);
            if(res.data.isSucess){
                bindFormData(res.data.model.fields.request)
            }
            else{
                setIsLoading(false);
            }
        
        })
        .catch(err=>{
            console.log('err=>',err);
            setIsLoading(false);
        })
    }

    const bindFormData = (data) => {
        try {
            let firstResiObj = {}, secResiObj = {} ;
            let idx = 0; 
            setIdNum(data.ApplicantDtls.IDNum);
            if(data.TaxStatus){
    
                if(data.TaxStatus.TIN !== null) {
                    defTin = data.TaxStatus.TIN;
                }
                else {
                    defTin = data.ApplicantDtls.IDNum;
                }
               
                if(data.TaxStatus.ApplicantTIN){
                    if(data.TaxStatus.ApplicantTIN.length === undefined) {
                        firstResiObj = data.TaxStatus.ApplicantTIN;
                    }
                    else{
                        idx = data.TaxStatus.ApplicantTIN.length;
                    }
                } 
      
                if(idx === 1) {
                     firstResiObj = data.TaxStatus.ApplicantTIN[0];
                }
                else if(idx === 2){
                    setShowAddBtn(false);
                    firstResiObj = data.TaxStatus.ApplicantTIN[0];
                    secResiObj =data.TaxStatus.ApplicantTIN[1];
                }
         
                setTaxDetails({
                    CouOfTaxRes:defCountry.label, //default SG for Sole
                    TIN: defTin,  //default NRIC
        
                    PayTaxSGOnly:data.TaxStatus.PayTaxSGOnly, //nric from local storage
       
                    TaxClare:data.TaxClare === 'true'? true:false,
            
                    TaxNumber2:firstResiObj.TaxNumber,
                    CouOfTaxRes2:getObjInArray(firstResiObj.CouOfTaxRes,filterArray(countries,defCountry.value)),
                    AbleProvTIN2:getObjInArray(firstResiObj.AbleProvTIN,taxData.ableToProvideTinDDL.data),
                    ReasonUnableProvTIN2:firstResiObj.ReasonUnableProvTIN,
            
                    TaxNumber3:secResiObj.TaxNumber,
                    CouOfTaxRes3:getObjInArray(secResiObj.CouOfTaxRes,filterArray(countries,defCountry.value)),
                    AbleProvTIN3:getObjInArray(secResiObj.AbleProvTIN,taxData.ableToProvideTinDDL.data),
                    ReasonUnableProvTIN3:secResiObj.ReasonUnableProvTIN
                })
        
                setPayTaxSGOnlySelected(data.TaxStatus.PayTaxSGOnly !== null? data.TaxStatus.PayTaxSGOnly:'Y');
            }
    
            bindFATCARdo(data);

        }catch(ex){
            console.log('@TaxDetails ',ex);
        }
      
    }

    const getObjInArray = (iValue, array) => {
        const result = array.find( ({ value }) => value === iValue);
        return result;
    }

    const bindFATCARdo = (data) => {
            
        if (data.CRSFATCA){
 
            setUSCSelected(data.CRSFATCA.FATCAUSC !== null? data.CRSFATCA.FATCAUSC:'N');
            setUSPRSelected(data.CRSFATCA.FATCAUSPR !==null? data.CRSFATCA.FATCAUSPR:'N');
            setUSRSelected(data.CRSFATCA.FATCAUSR !==null?data.CRSFATCA.FATCAUSR:'N' );
            setNUSPSelected(data.CRSFATCA.FATCANUSP !==null? data.CRSFATCA.FATCANUSP:'Y');
        }
    } 

    const validateFATCA = (data) => {
        let valid=true;
        if(payTaxSGOnlySelected === ''){
            showErrMsg(config.error.RdoOption+' (Please select "Does your business pay tax to Singapore only")');
        }
        else if(USCSelected === null || USPRSelected === null || USRSelected === null || NUSPSelected === null){
            showErrMsg(config.error.RdoOption+' (FATCA)');
            valid = false;
        }
        else if(data.AbleProvTIN2 && data.AbleProvTIN2.value === 'Y') {
            if(data.TaxNumber2 === undefined || data.TaxNumber2.length === 0){
                showErrMsg('Input the blank field (Tax Identification Number (TIN))');
                valid = false;
            }
        }
        else if(data.AbleProvTIN3 && data.AbleProvTIN3.value === 'Y') {
            if(data.TaxNumber3 === undefined || data.TaxNumber3.length === 0){
                showErrMsg('Input the blank field (Tax Identification Number (TIN))');
                valid = false;
            }
        }
        else {
            valid = true;
        }
        return valid;
    }
    
    const saveTaxDetails = (params) =>{
        setIsSaving(true);
        service.post(detailsType,params).then(res=>{
            setIsSaving(false);
            let resData = res.data;
            if(resData.isSucess){
                goNext();
            }
            else{
                showErrMsg(config.error.SaveApiFailed);
            }      
        })
        .catch(err => {
            console.log("err=>",err);
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        });
    }

    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            history.push(config.route.UploadDetails);
        }
    }
    
    let formatJsonParams = function(data) {

        let applicantObj = {}
        let applicantArray = [];

        if(payTaxSGOnlySelected === 'N') {
            applicantObj = {
                Order:1,
                NRIC:idNum,  
                TaxNumber: data.TaxNumber2,
                CouOfTaxRes:data.CouOfTaxRes2.value,
                AbleProvTIN:data.AbleProvTIN2.value,
                ReasonUnableProvTIN:data.ReasonUnableProvTIN2
            }
            applicantArray.push(applicantObj);
        }

        if(!showAddBtn){
            applicantObj = {
                Order:2,
                NRIC:idNum,   //store nric
                TaxNumber: data.TaxNumber3,
                CouOfTaxRes:data.CouOfTaxRes3.value,
                AbleProvTIN:data.AbleProvTIN3.value,
                ReasonUnableProvTIN:data.ReasonUnableProvTIN3
            }

            applicantArray.push(applicantObj);
        }

        let params={
            TaxStatus:{
                TIN:data.TIN,
                CouOfTaxRes:'SG', //default SG
                PayTaxSGOnly:payTaxSGOnlySelected,
                ApplicantTIN: applicantArray
            },
            CRSFATCA:{
                IsActiveBizEntity:'',
                CRSStatus:'',
                FATCAUS:'',
                FATCABIZ:'',

                FATCAUSC:USCSelected,
                FATCAUSPR:USPRSelected,
                FATCAUSR:USRSelected,
                FATCANUSP:NUSPSelected
            },
            TaxClare: data.TaxClare
        }
        return params;
    }

    const filterArray =(data, fValue) =>{
        
        const fArray = data.filter( d => d.value !== fValue);
        return fArray;
    }

    const filterCouOfResi = (fValue) =>{
 
        let couArray = filterArray(countries, defCountry.value);
        return filterArray(couArray,fValue);
    }

    

    const handleFATCAListChange = React.useCallback(
        (e, id) => {
            let tempUSCSelected = USCSelected;
            let tempUSPRSelected = USPRSelected;
            let tempUSRSelected = USRSelected;
            switch(id) {
                case fatcaList[0].id: setUSCSelected(e.value); tempUSCSelected =e.value;
                break;
                case fatcaList[1].id: setUSPRSelected(e.value); tempUSPRSelected = e.value;
                break;
                case fatcaList[2].id: setUSRSelected(e.value); tempUSRSelected= e.value;
                break;
                case fatcaList[3].id: setNUSPSelected(e.value)
                break;
            }
         
            setDefaultNUSPValue(tempUSCSelected,tempUSPRSelected,tempUSRSelected);
        }
    );

    const setDefaultNUSPValue = (USC,USPR,USR) =>{
     
        if(USC==='N' && USPR==='N' && USR==='N'){
            setNUSPSelected('Y');
            setDisableNUSP(true);
        }
        else {
            setNUSPSelected('N');
            setDisableNUSP(true);
        }
    }
    
    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }
    const showReasonUnableProvTIN2 = () =>{
 
        if(taxDetails.AbleProvTIN2){
            if(taxDetails.AbleProvTIN2.value === taxData.ableToProvideTinDDL.data[2].value){
          
                return true;
            }
        }
        return false;
    }

    const showReasonUnableProvTIN3 = () =>{
 
        if(taxDetails.AbleProvTIN3 !== undefined){
            if(taxDetails.AbleProvTIN3.value === taxData.ableToProvideTinDDL.data[2].value){
                return true;
            }
        }
        return false;
    }

  

    if(isLoading) {
        return(
            <Loading />
        )
    }

    return (
        <div className="container-fluid">
             <SubHeader />
             <FormContainer>
             <Form onSubmitClick={handleSubmit} 
                    initialValues={taxDetails}
                    key={JSON.stringify(taxDetails)}
                    render={(formRenderProps) => (
                    <FormElement>
                        <fieldset>
                            <Field component={FormTitle} id={'fst1'} 
                                name={taxData.formContainerTitle.T1.name} />

                            <Field component={FormSubTitle} id={'fstST1'} 
                                    name={taxData.formSubTitle.ST1}   />

                            <FieldWrapper>
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblCnOfTaxResi'} leftLabelName={taxData.label.cnOfTaxResi}
                                    id={'CnOfTaxResi'} name={taxDetails.CouOfTaxRes} />

                                <Field component={CusFormInput} 
                                    leftLabelId={'lblTIN'} leftLabelName={taxData.label.taxIN} 
                                    id={'TIN'} name={'TIN'} placeholder={'Please input'}  
                                    maxLength={20}
                                    validator={tinValidator} />

                                <CusRadioButton name="rdoPayTaxSGOnly" leftValue='Y' rightValue='N' disabled={false}
                                    label={taxData.label.payTaxSGOnly} 
                                    onChange={e => {
                                        setPayTaxSGOnlySelected(e.value);
                                        formRenderProps.onChange('TaxNumber'+2, { value: '' });
                                        formRenderProps.onChange('CouOfTaxRes'+2, { value: '' });
                                        formRenderProps.onChange('AbleProvTIN'+2, { value: '' });
                                        formRenderProps.onChange('ReasonUnableProvTIN'+2 , { value: '' });
                                        couOfResiObj = {}

                                        setShowAddBtn(true); //hide show btn
                                        formRenderProps.onChange('TaxNumber'+3, { value: '' });
                                        formRenderProps.onChange('CouOfTaxRes'+3, { value: '' });
                                        formRenderProps.onChange('AbleProvTIN'+3, { value: '' });
                                        formRenderProps.onChange('ReasonUnableProvTIN'+3 , { value: '' });
                                        couOfResiObj3 = {}
                                    }} checkedValue={payTaxSGOnlySelected} />

                                {payTaxSGOnlySelected==='N'? 
                                <div>
                                <TaxResidence order={2} fProps={formRenderProps} 
                                    array={filterArray(countries,defCountry.value)}
                                    show={showReasonUnableProvTIN2()}
                                    onCouOfTaxResChange={v=>{
                                        if(v !== null){
                                            if(v.value === couOfResiObj3.value) {
                                                formRenderProps.onChange('CouOfTaxRes'+2, { value: '' });
                                                showErrMsg('Oops! Duplicate country found. Do remove one of the duplicate countries and re-try.')
                                                return;
                                            }
                                            couOfResiObj = v;
                                        }
                                    }} /> 
                                <FieldWrapper>
                                {showAddBtn? 
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <span  
                                            onClick={ e => {
                                                e.preventDefault();
                                                if(formRenderProps.valueGetter('CouOfTaxRes'+2) === '' || formRenderProps.valueGetter('CouOfTaxRes'+2) === null || formRenderProps.valueGetter('CouOfTaxRes'+2) === undefined) {
                                                    showErrMsg('The business is also a tax resident of: Select drop down list')
                                                }
                                                else {
                                                    setShowAddBtn(false); //hide show btn
                                                }
                                            }}>
                                            <span className="k-icon k-i-plus-outline" style={{fontSize:'24px', marginRight:'5px', color:'grey'}}></span>
                                            <label>{taxData.label.addCntyBtn}</label>
                                        </span>
                                    </div>
                                </div> :
                                <div>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="box text-right" onClick={e=>{
                                       
                                            e.preventDefault();
                                        
                                            setShowAddBtn(true); //hide show btn
                                            formRenderProps.onChange('TaxNumber'+3, { value: '' });
                                            formRenderProps.onChange('CouOfTaxRes'+3, { value: '' });
                                            formRenderProps.onChange('AbleProvTIN'+3, { value: '' });
                                            formRenderProps.onChange('ReasonUnableProvTIN'+3 , { value: '' });
                                            couOfResiObj3 = {}
                                        }}>
                                            <label style={{marginRight:'10px'}}>REMOVE</label>
                                            <span className="k-icon k-i-delete" style={{fontSize:'24px', color:'grey'}}></span>
                                        </div>
                                    </div>
                                </div>

                                <TaxResidence order={3} fProps={formRenderProps} 
                                    array={filterArray(countries,defCountry.value)}
                                    show={showReasonUnableProvTIN3()}
                                    onCouOfTaxResChange={ v => {
                                        if(v !== null){
                                            if(v.value === couOfResiObj.value) {
                                                formRenderProps.onChange('CouOfTaxRes'+3, { value: '' });
                                                showErrMsg('Oops! Duplicate country found. Do remove one of the duplicate countries and re-try.')
                                                return;
                                            }
                                            couOfResiObj3 = v;
                                        }
                                    }}
                                    /> 
                                </div>
                                }
                                </FieldWrapper>
                                </div>
                                : null }
                             
                            </FieldWrapper>

                            <div style={{paddingTop: "10px"}}> <hr className="greyPanelLine" /> </div>

                            <Field component={FormSubTitle} id={'fstST2'} 
                                    name={taxData.formSubTitle.ST2}   />

                            <FieldWrapper>

                            <CusRadioButton name={fatcaList[0].id} leftValue='Y' rightValue='N' 
                                    disabled={false} label={fatcaList[0].lblname} 
                                    onChange={handleFATCAListChange } checkedValue={USCSelected} />

                            <CusRadioButton name={fatcaList[1].id} leftValue='Y' rightValue='N' 
                                    disabled={false}  label={fatcaList[1].lblname} 
                                    onChange={handleFATCAListChange } checkedValue={USPRSelected} />

                            <CusRadioButton name={fatcaList[2].id} leftValue='Y' rightValue='N' 
                                    disabled={false} label={fatcaList[2].lblname} 
                                    onChange={handleFATCAListChange } checkedValue={USRSelected} />

                            <CusRadioButton name={fatcaList[3].id} leftValue='Y' rightValue='N'
                                    disabled={disableNUSP}  label={fatcaList[3].lblname} 
                                    onChange={handleFATCAListChange } checkedValue={NUSPSelected} />


                            </FieldWrapper>

                            <div style={{paddingTop: "10px"}}> <hr className="greyPanelLine" /> </div>

                            <Field component={FormTitle} id={'fst2'} name={taxData.formContainerTitle.T2.name} />

                            <Field name={'TaxClare'} label={taxData.termsSole}  id={'termsinput'}
                                component={TermsFormCheckboxNoErrMsgDisplay} validator={termsValidator} />

                        <FieldWrapper>        
                        <CusProgressBar  bgcolor={item.bgcolor} completed={item.completed} /> 

                        <div className="row around-xs inputPair elementVisible" style={{ paddingBottom: "20px" }}>
                            <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <button type={'button'} className="btn btn-back" onClick={(e) => { e.preventDefault(); history.push(config.route.DelegationDetails)}}>{config.btnName.Back}</button>
                                <button type={'submit'} className="k-button btn btn-success btn-float-right"  disabled={!formRenderProps.valid}>{config.btnName.Next}</button>
                            </div>
                        </div> 
                        </FieldWrapper>

                        {/* {isError && <CusNotification msg={errMsg} closable={true} status={'error'} 
                                onClose={()=>{ setIsError(false)}} />} */}
                        <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} />
                        </fieldset>
                    </FormElement>
                    )}>
             </Form>
             </FormContainer>
             {isSaving && <Loading />}  
        </div>
    )
}

export default TaxDetails